import { render, staticRenderFns } from "./requirements-section.vue?vue&type=template&id=2e3982ea&scoped=true"
import script from "./requirements-section.vue?vue&type=script&lang=js"
export * from "./requirements-section.vue?vue&type=script&lang=js"
import style0 from "./requirements-section.vue?vue&type=style&index=0&id=2e3982ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3982ea",
  null
  
)

export default component.exports